<template>
  <box-model title="种植品类占比">
    <template v-slot:content>
      <div class="container">
        <div id="echart" class="con"></div>
        <div class="show-part flex-y-center">
          <div class="sm">
            <div class="s-title">总面积</div>
            <div class="s-con">{{ detail.totalArea || 0 }}<span class="t">亩</span></div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts'
  import { getPercentageOfCropArea, getTotalData } from "@/api/index";
  export default {
    data() {
      return {
        detail: {}
      }
    }, 
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted(){
      this.getPercentageOfCropAreaEvent();
    },
    methods: {
      getPercentageOfCropAreaEvent() {
        getPercentageOfCropArea().then((res) => {
          this.detail = res.data || {};
          const result = res?.data?.vsRatio || [];
          result.forEach((item) => {
            item["name"] = item.varietiesName;
            item["value"] = item.area;
          })
          if(result.length){
            let option = {
              tooltip : {
                trigger: 'item',
                formatter: function(item){
                  let result = `
                    <div style="padding: 12px;z-index:1001">
                      <div style="color: #3E3E3E;font-size: 15px;">${item.name}</div>
                      <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                      <div style="display: flex;align-items: center;">
                        <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                        <div style="color: #000E2B;font-size: 15px;margin-left: 4px;line-height: 16px;">种植面积：${item.value}亩</div>  
                      </div>
                    </div>
                  `;
                  return result;
                },
                backgroundColor: '#fff',
              },
              color:['#8fc31f','#f35833','#00ccff','#ffcc00','#f5e965','#a74faf'],
              series: [
                {
                  name: '资源总量构成',
                  type: 'pie',
                  center: ['50%', '45%'],
                  radius: ['50%', '70%'],
                  data: result,
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  },
                  itemStyle: {
                    normal: {
                      label:{ 
                        show: true, 
                        formatter: function(param){
                          return `${param.name}：${Math.round(param.percent)}%`
                        },
                        fontSize : 12,
                      }
                    },
                    labelLine :{show:true}
                  }
                }
              ]
            };
            const myChart = echarts.init(document.getElementById("echart"));
            myChart.setOption(option);
          }
        });
      }
    }
  }
</script>
<style scoped lang="less">
  .container {
    position: relative;
    width: 100%;
    height: 210px;
    .con {
      position: relative;
      z-index: 0;
      width: 100%;
      height: 210px;
    }
    .show-part {
      position: absolute;
      z-index: 999;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 40%;
      height: 40%;
      .sm {
        width: 100%;
        .s-title {
          font-size: 15px;
          font-weight: 400;
          color: rgba(255,255,255,0.702);
          line-height: 15px;
          text-align: center;
        }
        .s-con {
          font-size: 24px;
          font-weight: 700;
          color: #FFFFFF;
          line-height: 24px;
          text-align: center;
          margin-top: 10px;
          .t {
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 6px;
          }
        }
    }
    }
  }
</style>